import React, { useEffect, useState } from 'react';
import { UserProfileUI } from './UserProfile/ui';
import { getBoolean } from 'src/helpers/common/localStorage';
import { REACT_APP_AUTH } from 'src/utils/config';
import Client from 'src/model/User';
import { useDispatch } from 'react-redux';
import { setLoading } from 'src/redux/loading/loadingSlice';
import { api } from 'src/services/api';
import { AlertMessage } from 'src/model/AlertMessage';
import { useLocation } from 'react-router-dom';

export const UserProfileScreen: React.FC = (): JSX.Element => {
  const [signed, setSigned] = useState<boolean>(
    getBoolean(String(REACT_APP_AUTH))
  );
  const [user, setUser] = useState<Client>();
  const [alertMessage, setAlertMessage] = useState<AlertMessage[]>([]);
  //  TODO ADD Params
  const dispatch = useDispatch();
  const location = useLocation();
  const isSalesTab =
    new URLSearchParams(location.search).get('tab') === 'vendas';

  const isAuth = async (): Promise<void> => {
    setTimeout(async () => {
      if (getBoolean(String(REACT_APP_AUTH)) !== signed) {
        setSigned(getBoolean(String(REACT_APP_AUTH)));
        return;
      } else {
        isAuth();
      }
    }, 500);
  };

  const getUser = async (): Promise<void> => {
    if (signed) {
      dispatch(setLoading(true));
      try {
        const response = await api.get(
          isSalesTab ? `/user/summary` : `/user/findeone`
        );
        if (response.status === 200) {
          setUser(response.data as Client);
          if (!isSalesTab && response.data.id) {
            const alert = await api.get<AlertMessage[]>(
              `/alertMessage/findAll/${response.data.id}`
            );
            setAlertMessage(alert.data);
          } else {
            setAlertMessage([]);
          }
        }
      } catch (error) {
        console.error('Erro ao buscar o usuario:', error);
      } finally {
        dispatch(setLoading(false));
      }
    } else {
      isAuth();
    }
  };

  useEffect(() => {
    isAuth();
    // eslint-disable-next-line
  }, [signed]);

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, [signed, location.search]);

  return (
    <>
      {user ? (
        <UserProfileUI user={user} notifications={alertMessage} />
      ) : (
        'carregando'
      )}
    </>
  );
};
